// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"861":"5a3940ab","912":"b7f1127a"}[chunkId] + ".chunk.js";
};